import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})

export class StripeService {

  constructor(private http: HttpClient) {}

  // List of stripe apis here

  getStripeProducts() {
    return this.http.post(environment.apiUrl + '/api/stripe/products', httpOptions);
  }

}
